// src/Admin/Api.js
const API_URL = 'https://gymdich.de'; // Deine Backend-URL
//const API_URL = "http://localhost:8080";

// Funktion zum Abrufen des Admin-Texts
export const getTraining = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/training/getTraining`, { // Ändere die URL hier
        method: 'GET', // GET-Methode angeben
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
        },
    });
    if (!response.ok) {
        const responseBody = await response.text();  // This reads the body as text
        console.error('Response error body:', responseBody);
        throw new Error('Fehler beim Abrufen des Admin-Texts');
    }
    return await response.json();
};

// Funktion zum Speichern des Admin-Texts
export const saveTrainingText = async (trainingText) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/training/saveTrainingText`, { // Ändere die URL hier
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(trainingText),
    });
    if (!response.ok) {
        throw new Error('Fehler beim Speichern des Admin-Texts');
    }
    return await response.json();
};

// Funktion zum Abrufen des Admin-News
export const fetchAdminNews = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/adminNews/1`, { // URL auf adminNews ändern
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
    if (!response.ok) {
        throw new Error('Fehler beim Abrufen der Admin-News');
    }
    return await response.json();
};

// Funktion zum Speichern der Admin-News
export const saveAdminNews = async (adminNews) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/adminNews/save`, { // URL auf adminNews ändern
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(adminNews),
    });
    if (!response.ok) {
        throw new Error('Fehler beim Speichern der Admin-News');
    }
    return await response.json();
};

//zum erstellen des events
export const createEvent = async ({ headline, news, template, dateInputs }) => {
    const token = localStorage.getItem('token');
    // Construct the object to send in the request body
    const createEventDTO = {
        headline,    // Using shorthand to assign `headline`
        news,        // Shorthand for `news`
        template,
        dateInputs
    };

    // Send the POST request with the body
    const response = await fetch(`${API_URL}/api/event/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(createEventDTO), // Pass the created object into JSON.stringify
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;
    } else {
        throw new Error("Failed to create event");
    }
};

export const getEvent = async () => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/event/eins`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const getAllEventDates = async () => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/event/dates/getAll`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const getAllVotedEventDates = async (username) => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/event/dates/getAllVotedDates/` + username, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const saveDateVotes = async (dateToVote, username) => {
    const token = localStorage.getItem('token');
    const saveDateVotesDTO = {
        dateToVote,
        username
    };

    const response = await fetch(`${API_URL}/api/event/dates/saveVotes`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(saveDateVotesDTO),
    });
    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const getDateVoteCounts = async () => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/event/dates/getDateVoteCount`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};


export const getAllTrainingVotes = async () => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/training/getTrainingsVotes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const trainingVote = async ({ username, vote }) => {
    const token = localStorage.getItem('token');
    // Construct the object to send in the request body
    const trainingVoteDTO = {
        username,
        vote
    };
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/training/trainingVote`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(trainingVoteDTO),
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};


export const getAdminisAbsent = async () => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/training/getAdminisAbsent`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const getIfUserVoted = async (name) => {
    const token = localStorage.getItem('token');
    try {
        // Send the GET request to fetch the vote status
        const response = await fetch(`${API_URL}/api/training/getIfUserVoted/${name}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json', // Set accept header to handle JSON response
                'Authorization': `Bearer ${token}`,
            },
        });

        // Check if the response is OK (status code 200-299)
        if (response.ok) {
            const data = await response.json();  // Parse the response as JSON
            return data;  // Return the data (could be a string or number, depending on the backend)
        } else {
            throw new Error('Failed to fetch user vote status');
        }
    } catch (error) {
        // Handle network errors or any other errors
        console.error(error);
        throw error;  // Rethrow error to handle it further up the chain
    }
};

export const getTrainingsVotesAdmin = async () => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/training/getTrainingsVotesAdmin`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const getEventDates = async (event_date_id) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/events/${event_date_id}/dates`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (response.ok) {
        const data = await response.json();
        return data; // Gibt die Event-Daten zurück, vermutlich ein Array mit Datumsangaben
    } else {
        throw new Error("Failed to fetch event dates");
    }
};

export const getVoteCountPerDateWithName = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/event/dates/getVoteCountPerDateWithName`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (response.ok) {
        const data = await response.json();
        return data; // Gibt die Event-Daten zurück, vermutlich ein Array mit Datumsangaben
    } else {
        throw new Error("Failed to fetch event dates");
    }
};

export const createEventDates = async (event_date_id, dates) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/events/${event_date_id}/dates`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ dates }), // Erwartet: { dates: [date1, date2, ...] }
    });

    if (!response.ok) {
        throw new Error("Fehler beim Speichern der Datumsangaben");
    }

    return response.json();
};

export const setFinalEventDate = async (event_date_id) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/event/setFinalEventDate/${event_date_id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error("Fehler beim Speichern der finalen Datumsangaben");
    }

    return response.json();
};


export const getFinalEventDate = async (username) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/event/getFinalEventDate`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (response.ok) {
        const data = await response.json();
        return data; // Gibt die Event-Daten zurück, vermutlich ein Array mit Datumsangaben
    } else {
        throw new Error("Failed to fetch event dates");
    }
};

export const votingFinalEventDate = async (username, vote) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/event/votingFinalEventDate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ username, vote }),
    });

    if (!response.ok) {
        throw new Error("Failed to submit vote");
    }

    return await response.json(); // optional: falls das Backend eine Antwort zurückgibt
};

export const getIfUserVotedFinalEvent = async (name) => {
    const token = localStorage.getItem('token');
    try {
        // Send the GET request to fetch the vote status
        const response = await fetch(`${API_URL}/api/event/getIfUserVoted/${name}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json', // Set accept header to handle JSON response
                'Authorization': `Bearer ${token}`,
            },
        });

        // Check if the response is OK (status code 200-299)
        if (response.ok) {
            const data = await response.json();  // Parse the response as JSON
            return data;  // Return the data (could be a string or number, depending on the backend)
        } else {
            throw new Error('Failed to fetch user vote status');
        }
    } catch (error) {
        // Handle network errors or any other errors
        console.error(error);
        throw error;  // Rethrow error to handle it further up the chain
    }
};

export const getFinalEventVotesValues = async () => {
    const token = localStorage.getItem('token');
    // Send the GET request to fetch the event by its ID
    const response = await fetch(`${API_URL}/api/event/getFinalEventVotesValues`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    // Handle the response
    if (response.ok) {
        const data = await response.json();
        return data;  // Return the event data
    } else {
        throw new Error("Failed to fetch event");
    }
};

export const getEventVoteParticipateWithName = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/event/getEventVoteParticipateWithName`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (response.ok) {
        const data = await response.json();
        return data; // Gibt die Event-Daten zurück, vermutlich ein Array mit Datumsangaben
    } else {
        throw new Error("Failed to fetch event dates");
    }
};

export const saveCheckboxes = async (username, anwesenheitStatus) => {
    try {
        const response = await fetch(`${API_URL}/api/users/${username}/anwesenheit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`, // Token hinzufügen
            },
            body: JSON.stringify({ anwesenheit: anwesenheitStatus }), // Korrekte JSON-Struktur
        });

        // Überprüfe, ob die Antwort ok ist
        if (!response.ok) {
            const errorResponse = await response.text(); // Textinhalt der Antwort laden
            throw new Error(`Fehler beim Speichern des Anwesenheits-Status: ${errorResponse}`);
        }

        const data = await response.text(); // Hier wird die Antwort als Text verarbeitet
        return data; // Gibt die Bestätigung oder den Text zurück
    } catch (error) {
        console.error("API Error: ", error);
        throw error; // Wirf den Fehler weiter, um ihn im UI zu behandeln
    }
};

// Funktion zum Einloggen
export const login = async (username, password) => {
    try {
        const response = await fetch(`${API_URL}/api/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password }),
        });

        const data = await response.json();

        // Prüfen, ob Backend Fehler zurückgibt
        if (!response.ok) {
            throw new Error(typeof data === "string" ? data : data.message || "Login fehlgeschlagen");
        }

        return { token: data.token, name: data.username, role: data.role };
    } catch (error) {
        console.error("Login error:", error.message);
        throw error;
    }
};


// Funktion zum Registrieren (optional)
export const register = async (username, password, chiffre) => {
    try {
        const response = await fetch(`${API_URL}/api/users/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": ""
            },
            body: JSON.stringify({ username, password, chiffre }),
        });

        const data = await response.json(); // Gibt die Bestätigung oder das neu erstellte Benutzerobjekt zurück
        return data;
    } catch (error) {
        console.error('Registrierungsfehler:', error.message);
        throw error;
    }
};

// Füge deleteUser als exportierte Funktion hinzu
export const deleteUser = async () => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${API_URL}/api/users/delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Fehler beim Löschen des Accounts: ${errorText}`);
            throw new Error(`Fehler beim Löschen des Accounts: ${errorText}`);
        }

        // Optional: JSON-Antwort prüfen, falls vom Server erwartet
        const data = await response.json().catch(() => null); // Wenn kein JSON gesendet, gibt null zurück
        return data || { message: 'Benutzer erfolgreich gelöscht' }; // Standardnachricht, falls kein JSON
    } catch (error) {
        console.error('Fehler beim Löschen:', error);
        throw error;
    }
};
// src/api.js

// Beispiel für eine API-Funktion
export const editUser = async (newName) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${API_URL}/api/users/editUsername/${newName}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Fehler bei der Bearbeitung: ${errorText}`);
        }

        return response.data;
    } catch (error) {
        console.error('API-Fehler:', error);
        throw error;
    }
};

export const editEmail = async (users) => {
    try {
        const response = await fetch(`${API_URL}/api/users/editEmail`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(users),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Fehler bei der Bearbeitung: ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('API-Fehler:', error);
        throw error;
    }
};


export const auth = async () => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${API_URL}/api/users/isAuthenticated`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Token z. B. aus localStorage
            },
        });
        
        if (!response.ok) {
            return false;
        }
        return true;
    } catch (error) {
        return false;
    }
};


